import { ButtonGroup, Card, LoadingSpinner, Modal, Tooltip, Icon } from 'pepsico-ds'
import React, { useState, useEffect, useMemo, useRef } from 'react'
import ModalFilters from './ModalFilters'
import { formatNumberWithCommas, returnHyphenIfNull, splitValueWithUnit, handleDomToImgDownloadPdf } from '../../utils/utils'
import { Col, Row } from 'antd'
import { useSelector } from 'react-redux'
import ProductivityChart from '../Charts/PowerSteeringChart/ProductivityChart'
import MOMProductivityChart from '../Charts/PowerSteeringChart/MOMProductivityChart'
import AntdTable from '../Table/AntdTable'
import ThreeBarsChart from '../Charts/PowerSteeringChart/ThreeBarsChart'
import { topBottomChartData, powersteeringMockData } from "../../mocks/powerSteeringData";
import LegendList from '../Charts/Legend/LegendList'
import SingleSelectDropdown from '../Dropdown/SingleSelectDropdown'
import VerticalStackedChart from '../Charts/PowerSteeringChart/VerticalStackedChart'
import { localStoreKeys } from '../../constants/localStoreKeys'
import NoData from '../NoData/NoData'
import CustomStackedChart from '../Charts/PowerSteeringChart/CustomStackedChart'
import { appConstants } from '../../constants/appconstants'
// import * as XLSX from 'xlsx';
// import { saveAs } from 'file-saver';
import { exportRowsToExcel } from '../../utils/excelExport';
import { saveAs } from 'file-saver';
import download_logo from '../../assets/download_logo.png'
import { trackModalView, getModalAttributes } from '../../utils/fullstory-utils';
import CustomButtons from '../Cards/CustomButtons'
import DropdownWithIcons from './DropdownWithIcons'
import { useToast } from '../../components/Toast/ToastContext';
import Vector from '../../assets/Vector.png'
import EDF_checked from "../../../src/assets/EDF_checked.svg";
import { staticNotes } from '../../constants/staticNotes';

const dataColumns = [
    { title: 'SECTOR', dataIndex: 'sector', key: 'sector', display: true, width: 70 },
    { title: 'BU', dataIndex: 'bu', key: 'bu', display: true, width: 50 },
    { title: 'COST LINE', dataIndex: 'costLine', key: 'costLine', display: true, width: 150 },
    { title: 'HCM PLANK', dataIndex: 'hcm', key: 'hcm', display: false, width: 150 },
    {
        title: `PRODUCTIVITY`, dataIndex: 'productivity', key: 'hcm', display: true, width: 200,
        children: [
            { title: 'ACTUAL', dataIndex: 'actual', key: 'actual', display: true },
            { title: 'PLAN', dataIndex: 'plan', key: 'plan', display: true },
            // { title: 'FORECAST', dataIndex: 'forecast', key: 'forecast', display: true },
        ]
    },
    { title: 'ACTUAL VS. PLAN', dataIndex: 'actual_plan', key: 'actual_plan', display: true, width: 150 },
    // { title: 'ACTUAL VS. FCST', dataIndex: 'actual_forecast', key: 'actual_forecast', display: true },
]

const datasource = [
    { sector: 'AMESA', bu: 'India', costLine: '2.1', hcm: null, actual: 2.1, plan: 2.1, forecast: 2.1, actual_plan: 2.1, actual_fcst: 2.1 },
    { sector: 'AMESA', bu: 'UAE', costLine: '2.1', hcm: null, actual: 2.1, plan: 2.1, forecast: 2.1, actual_plan: 2.1, actual_fcst: 2.1 },
    { sector: 'AMESA', bu: 'Nigeria', costLine: '2.1', hcm: null, actual: 2.1, plan: 2.1, forecast: 2.1, actual_plan: 2.1, actual_fcst: 2.1 },
]

const dropdownValue = [
    { displayText: 'Cost Line', id: 1, value: 'costLine' },
    { displayText: 'HCM Plank', id: 2, value: 'hcm' }
]


const legendsChart2 = [
    { name: 'Actual', color: '#0078A7' },
    { name: 'Plan', color: '#B05788' },
    { name: 'Rest of the year Forecast', color: '#FF891C' },
]


const stackedBarDetails = [
    {
        "name": "PBNA",
        "A&M NON-WORKING": "2",
        "FACILITIES": "1",
        "INGREDIENTS": "1",
        "MAINT, REPAIRS, OPS": "1",
        "PACKAGING": "15",
        "SUPPLY CHAIN": "2",
        "SWEETENERS": "1"
    },
    {
        "name": "AMESA",
        "BUSINESS SERVICES": "1",
        "COMMODITIES": "2",
        "FRUITS & VEGETABLES": "1",
        "INGREDIENTS": "3",
        "MAINT, REPAIRS, OPS": "1",
        "SUPPLY CHAIN": "1",
        "SWEETENERS": "1"
    },
    {
        "name": "APAC",
        "BUSINESS SERVICES": "3",
        "CAPITAL": "23",
        "COMMODITIES": "4",
        "FACILITIES": "8",
        "FRUITS & VEGETABLES": "1",
        "INGREDIENTS": "1",
        "MAINT, REPAIRS, OPS": "4",
        "PACKAGING": "15",
        "SUPPLY CHAIN": "2"
    }
]
const stackedChartLegends = [
    {
        "name": "Actual",
        "color": "#0078A7"
    },
    {
        "name": "Plan",
        "color": "#B05788"
    },
    {
        "name": "Forecast",
        "color": "#FF891C"
    }
]




function PowerSteeringModal({ openModal, setOpenModal, userData, selectedYear, capability, userDataLandingPage, landingPageFilters }) {
    // Track modal view when opened
    const MODAL_TITLE = 'Savings Report';

    useEffect(() => {
        if (openModal) {
            try {
                trackModalView(`${MODAL_TITLE} ${capability}`, 'view');
            } catch (error) {
                // Silent fail for tracking errors to not disrupt user experience
            }
        }
    }, [openModal, capability]);

    const handleClose = () => {
        try {
            trackModalView(`${MODAL_TITLE} ${capability}`, 'close');
        } catch (error) {
            // Silent fail for tracking errors
        }
        setOpenModal(false);
    };
    const powerSteeringRef = useRef()
    const productivitybySectorBURef = useRef()
    const MOMProductivityRef = useRef()
    const ProductivityCostLineTableRef = useRef()
    const ProductivityCostLineChartRef = useRef()
    const top5ProductivityProjectsRef = useRef()
    const bottom5ProductivityProjectsRef = useRef()
    const [powersteeringData, setPowersteeringData] = useState({})// useState(powersteeringMockData)
    const [loader, setLoader] = useState(false)
    const [buttonGroupItems, setButtonGroupItems] = useState([])
    const isLoading = useSelector((state) => state?.loader?.isLoading);
    const [costLineHcmPlank, setCostLineHcmPlank] = useState([dropdownValue[0]])
    const [columns, setColumns] = useState(dataColumns)
    const [selectedYearFilter, setSelectedYearFilter] = useState('')
    const feedbackFormUrl = useSelector((state) => state?.localData?.data[localStoreKeys.feedbackFormUrl]);
    const [isYTDDisplay, setIsYTDDisplay] = useState(false)
    
    const getPowersteeringData = (value) => {
        let appList = [];
        if(value?.data?.type==="SUCCESS_POWERSTEERING_DETAIL_VIEW_ACTION") {
            
            setPowersteeringData(value.data)
            appList = value?.data?.apps
        }
        if (value.modalName == "PowerSteering" && appList && appList.length > 0) {
            const tempbuttonGroupItems = appList
                ?.filter(item => item.isActive)
                .map(item => ({
                    label: item.app,
                    onClick: () => window.open(item.url, "_blank"),
                }));

            setButtonGroupItems(tempbuttonGroupItems)
        }
        const currentYear = new Date().getFullYear()
        setIsYTDDisplay(currentYear == value.fromDateSelected?.[0]?.["displayText"] ? true : false)
    }   
    console.log("costLineHcmPlank: ", costLineHcmPlank)
    
    const onDropdownChange = (val) => {
        if(val && val.length>0) {
            setCostLineHcmPlank(val)
            let selectedValue = val[0]?.value; // Get the selected value safely
    
            let tempCols = columns.map(item => {
                if (item.dataIndex === "costLine") {
                    return { ...item, display: selectedValue === "costLine" }; // Hide if "costline" is selected, show otherwise
                }
                if (item.dataIndex === "hcm") {
                    return { ...item, display: selectedValue !== "costLine" }; // Show if "costline" is selected, hide otherwise
                }
                return item; // Keep other columns unchanged
            });
    
            setColumns(tempCols);
        }
        
    }

    // console.log("powersteeringData", powersteeringData);
    // console.log("columns-antd", columns);

    const productivityActual = splitValueWithUnit(powersteeringData?.headerDetailsDto?.productivityActual)
    const productivityPlan = splitValueWithUnit(powersteeringData?.headerDetailsDto?.productivityPlan)
    // const productivityForecast = splitValueWithUnit(powersteeringData?.headerDetailsDto?.productivityForecast)
    const productivityYtdPlan = splitValueWithUnit(powersteeringData?.headerDetailsDto?.productivityYtdPlan)
    const bwPlan = splitValueWithUnit(powersteeringData?.headerDetailsDto?.bwVsPlan)
    const dataAvailableNote = powersteeringData?.headerDetailsDto?.latestFileName
    const flag = dataAvailableNote ? dataAvailableNote === ("P13") : false;
    const momProductivityDetails = powersteeringData?.momProductivityDetails
    const top5ProjectDetails = powersteeringData?.top5ProjectDetails
    const bottom5ProjectDetails = powersteeringData?.bottom5ProjectDetails
    const ytdProductivityDetails = powersteeringData?.ytdProductivityDetails
    const ytdProductivityByCostLineDimension = powersteeringData?.ytdProductivityByCostLineDimension
    const ytdProductivityByHcmPlankDimension = powersteeringData?.ytdProductivityByHcmPlankDimension
    const productivityByCostLineDimension = powersteeringData?.productivityByCostLineDimension
    const productivityByHcmPlankDimension = powersteeringData?.productivityByHcmPlankDimension
    const buColorMap = powersteeringData?.buColorMap
    const isEDFIntegrated = powersteeringData?.edfintegrated;

    const dataSource = costLineHcmPlank?.[0]?.['value'] === 'costLine' ? ytdProductivityByCostLineDimension : ytdProductivityByHcmPlankDimension
    const productivityChartData = costLineHcmPlank?.[0]?.['value'] === 'costLine' ? productivityByCostLineDimension : productivityByHcmPlankDimension
    const bwPlanColor = Number(String(bwPlan?.['numericValue'] || "").replace("$", "")) < 0 ? "#AA001A" : "rgb(0, 106, 66)"
    
    const legendsChart1 = flag ? [
        { name: 'Actual', color: '#0078A7' },
        { name: 'Plan', color: '#B05788' },
    ] : [
        { name: 'YTD Actual', color: '#0078A7' },
        { name: 'YTD Plan', color: '#B05788' },
    ]
    // console.log("buColorMap", buColorMap)
    
    const getSelectedYear = (val) => {
        setSelectedYearFilter(val?.year)
    }
    // console.log("dataSource", dataSource);
    
    const sortedData = dataSource?.slice()?.sort((a, b) => {
        if (a.costLine === "null" && b.costLine !== "null") return 1;
        if (a.costLine !== "null" && b.costLine === "null") return -1;
        return 0;
    });

    // const downloadExcel = () => {
	// 	// Define the columns to keep and the desired order
	// 	const columnsToInclude = ["SECTOR", "BU", "COST LINE", "PRODUCTIVITY ACTUAL", "PRODUCTIVITY PLAN", "ACTUAL VS. PLAN"]		// Use uppercase for final header names
	// 	const columnMapping = {
    //         "sector": "SECTOR",
    //         "bu": "BU",
    //         "costLine": "COST LINE",
    //         "actual": "PRODUCTIVITY ACTUAL",
    //         "plan": "PRODUCTIVITY PLAN",
    //         "actual_plan": "ACTUAL VS. PLAN"
    //       };                       
	
	// 	// Transform the data
	// 	const transformedResultData = sortedData.map(item => {
	// 		const newValItem = {};
	// 		columnsToInclude.forEach(col => {
	// 			const originalKey = Object.keys(columnMapping).find(key => columnMapping[key] === col);
	// 			newValItem[col] = item[originalKey];
	// 		});
	// 		return newValItem;
	// 	});
	
	// 	// Create worksheet and workbook
	// 	const wsPowerSteeringModal = XLSX.utils.json_to_sheet(transformedResultData);
	// 	const wbPowerSteeringModal = XLSX.utils.book_new();
	// 	XLSX.utils.book_append_sheet(wbPowerSteeringModal, wsPowerSteeringModal, 'Sheet1');
	
	// 	// Convert workbook to binary array and save
	// 	const wbout = XLSX.write(wbPowerSteeringModal, { bookType: 'xlsx', type: 'array' });
	// 	const blob = new Blob([wbout], { type: 'application/octet-stream' });
	// 	saveAs(blob, 'YTD VIEW OF PRODUCTIVITY BY COST LINE (IN USD MILLION).xlsx');
	// };

    
    const downloadExcel = async () => {
        // Define the columns to keep and the desired order
        let columnsToInclude = [
            "SECTOR",
            "BU",
            "HCM PLANK",
            "PRODUCTIVITY ACTUAL",
            "PRODUCTIVITY PLAN",
            "ACTUAL VS. PLAN"
        ];
    
        let columnMapping = {
            "sector": "SECTOR",
            "bu": "BU",
            "hcm": "HCM PLANK",
            "actual": "PRODUCTIVITY ACTUAL",
            "plan": "PRODUCTIVITY PLAN",
            "actual_plan": "ACTUAL VS. PLAN"
        };
        if(costLineHcmPlank?.[0]?.['displayText']=='Cost Line') {
            columnsToInclude = [
                "SECTOR",
                "BU",
                "COST LINE",
                "PRODUCTIVITY ACTUAL",
                "PRODUCTIVITY PLAN",
                "ACTUAL VS. PLAN"
            ];
        
            columnMapping = {
                "sector": "SECTOR",
                "bu": "BU",
                "costLine": "COST LINE",
                "actual": "PRODUCTIVITY ACTUAL",
                "plan": "PRODUCTIVITY PLAN",
                "actual_plan": "ACTUAL VS. PLAN"
            };
        }
        
    
        // Transform the data
        const transformedResultData = sortedData.map(item => {
            const newValItem = {};
            columnsToInclude.forEach(col => {
                const originalKey = Object.keys(columnMapping).find(
                    key => columnMapping[key] === col
                );
                newValItem[col] = item[originalKey];
            });
            return newValItem;
        });
    
        await exportRowsToExcel({
            rows: transformedResultData,
            headers: columnsToInclude,
            fileName: 'YTD VIEW OF PRODUCTIVITY BY COST LINE (IN USD MILLION).xlsx',
        });
    };

    const { showToast } = useToast();


    
    const checkPDFDownloaded = (isPdfDownloaded, isModal, fileURL, isExcel, isTable, isJpeg) => {
        if(isPdfDownloaded){
            if(isModal){
                showToast('success', !isJpeg ? "PDF of full page successfully downloaded." : 'JPEG of full page successfully downloaded.', {
                    icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
                });
            } else if(isTable){
                showToast('success', !isJpeg ? "PDF of a table successfully downloaded." : 'JPEG of a table successfully downloaded.', {
                    icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
                });
            }
            else{
                showToast('success', !isJpeg ? "PDF of a chart successfully downloaded.": 'JPEG of a chart successfully downloaded.', {
                    icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
                });
            }
        }
        else if(isExcel){
            downloadExcel()
        }
        else{
            showToast('Error', "Failed to download. Please try again.", {
                icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
            });
        }   
      }

   
    
    return (
        <Modal
            onCloseModal={handleClose}
            primaryButtonProps={{
                onClick: handleClose,
                size: "medium",
                text: "Close",
                variant: "primary",
            }}
            showPrimaryButton={true}
            showLink={false}
            showSecondaryButton={false}
            showTertiaryButton={false}
            showAuxiliaryButton={false}
            showSlot={true}
            showModal={openModal}
            closeOnOutsideClick={false}
            hideCloseButton={false}
            type="XL"
            {...getModalAttributes(`${MODAL_TITLE} ${capability}`)}
        >
            <div ref={powerSteeringRef}>
                <div className="modal-title" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>
                        {userData.FirstName}, total savings reported for your category is <b>{formatNumberWithCommas(productivityActual['numericValue']) || 0}{productivityActual['unit']}</b>
                        {
                            isEDFIntegrated &&
                            <Tooltip direction="bottom" text={staticNotes.EDF_NOTE}>
                                <img src={EDF_checked} alt='image' style={{ width: '18px', height: '22px', marginLeft: "8px", overflow:"visible", marginBottom: "7px" }} />
                            </Tooltip>
                        }
                    </span>
                    
                    {
                        isLoading ? (
                            <></>
                        ) :                    
                        <>
                            {/* <ButtonGroup
                                style={{ marginRight: '2rem' }}
                                className="buy-con-button-group"
                                items={buttonGroupItems}
                                itemCount={2}
                                showMore
                                size="small"
                            /> */}
                            <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                <CustomButtons isModal={true} appList={powersteeringData?.apps} />
                                {/* <button onClick={() => handleDomToImgDownloadPdf(powerSteeringRef, "Power_Steering_Modal")}>PDF</button> */}
                                <span style={{float: 'right', position: 'relative', right: '2rem', bottom: '0.6rem'}}>
                                    <DropdownWithIcons modalRef={powerSteeringRef} kpiName={"Power_Steering_Modal"} isModal={true} checkPDFDownloaded={checkPDFDownloaded}/>
                                </span>
                            </span>
                        </>
                    }
                </div>
                {(powersteeringData?.lastUpdate) && <div className="modal-update-frequesncy">Data As On: {returnHyphenIfNull(powersteeringData?.lastUpdate)} | Refresh Frequency: {returnHyphenIfNull(powersteeringData?.refreshFrequency)}</div>}
                <ModalFilters modalName={"PowerSteering"} selectedYear={selectedYear} capability={capability} userData={userDataLandingPage} onParentCallback={getPowersteeringData} landingPageFilters={landingPageFilters} setLoader={setLoader} getSelectedYear={getSelectedYear} />
                <br />
                {dataAvailableNote && <div className="modal-note"><b>Note:</b> The Productivities reported are until <b>{dataAvailableNote}</b></div>}
                {<div className="modal-note"><b>Note:</b> <b>A&M</b> (Working & Non-working) | <b>Capital</b> are part of Indirects on PH. Please select respective filters in Category L1 to access them individually</div>}
                {<div className="modal-note"><b>Note:</b> Co-Man PR numbers are displayed separately in PH vs PR dashboard</div>}
                {<div className="modal-note"><b>Note:</b> IB Franchise (LATAM) Productivity is not part of this report</div>}
                <br />
                {
                    isLoading ?
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 300 }}>
                            <LoadingSpinner size={{ height: '80px', width: '80px' }} />
                        </div> :
                        <>
                            <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%", position: 'relative' }}>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Card style={{ height: '100%',display:'flex' }}>
                                <div className='header-kpi-wrapper'>
                                {
                                    productivityActual === null || productivityActual === undefined ? '' : <>
                                        <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                                            <>
                                                <div className="spend-modal-alphanumeric-value">
                                                    <div className='spend-modal-numeric-value'>{formatNumberWithCommas(productivityActual['numericValue']) || 0}</div>
                                                    <div className="spend-modal-alpha-value" style={{ display: "flex" }}>{productivityActual['unit']} </div>
                                                </div>
                                                <div className='spend-modal-total-spend-text'>Productivity Actual {!flag ? "(YTD)" : ""}</div>
                                            </>
                                        </Col>
                                    </>
                                }
                                {
                                    productivityYtdPlan === null || productivityYtdPlan === undefined ? '' :
                                        <>
                                            <div className="compass-modal-divider-verticle" />
                                            <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                                                <>
                                                    <div className="spend-modal-alphanumeric-value">
                                                        <div className='spend-modal-numeric-value'>{formatNumberWithCommas(productivityYtdPlan['numericValue']) || 0}</div>
                                                        <div className="spend-modal-alpha-value" style={{ display: "flex" }}>{productivityYtdPlan['unit']} </div>
                                                    </div>
                                                    <div className='spend-modal-total-spend-text'>Productivity Plan {!flag ? "(YTD)" : ""}</div>
                                                </>
                                            </Col>
                                        </>
                                }
                                {/* {
                                    productivityForecast === null || productivityForecast === undefined ? '' :
                                        <>
                                            <div className="compass-modal-divider-verticle" />
                                            <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                                                <>
                                                    <div className="spend-modal-alphanumeric-value">
                                                        <div className='spend-modal-numeric-value'>{formatNumberWithCommas(productivityForecast['numericValue']) || 0}</div>
                                                        <div className="spend-modal-alpha-value" style={{ display: "flex" }}>{productivityForecast['unit']} </div>
                                                    </div>
                                                    <div className='spend-modal-total-spend-text'>Productivity Forecast</div>
                                                </>
                                            </Col>
                                        </>
                                } */}
                                {
                                    bwPlan === null || bwPlan === undefined ? '' :
                                        <>
                                            <div className="compass-modal-divider-verticle" />
                                            <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                                                <>
                                                    <div className="spend-modal-alphanumeric-value">
                                                        <div className='spend-modal-numeric-value' style={{ color: bwPlanColor }}>{formatNumberWithCommas(bwPlan['numericValue']) || 0}</div>
                                                        <div className="spend-modal-alpha-value" style={{ display: "flex", color: bwPlanColor }}>{bwPlan['unit']} </div>
                                                    </div>
                                                    <div className='spend-modal-total-spend-text'>B/W vs Plan {!flag ? "(YTD)" : ""}</div>
                                                </>
                                            </Col>
                                        </>
                                }
                                {
                                    productivityPlan === null || productivityPlan === undefined || (flag) ? '' :
                                        <>
                                            <div className="compass-modal-divider-verticle" />
                                            <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                                                <>
                                                    <div className="spend-modal-alphanumeric-value">
                                                        <div className='spend-modal-numeric-value'>{formatNumberWithCommas(productivityPlan['numericValue']) || 0}</div>
                                                        <div className="spend-modal-alpha-value" style={{ display: "flex" }}>{productivityPlan['unit']} </div>
                                                    </div>
                                                    <div className='spend-modal-total-spend-text'>Productivity Plan (FY)</div>
                                                </>
                                            </Col>
                                        </>
                                }
                                </div>
                            </Card>
                            </Col> 
                            </Row>
                            <br />
                            <Row gutter={[10, 10]} justify="start" style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    
                                    <Card>
                                        <Row justify={"space-between"} style={{ width: "100%" }}>
                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <div ref={productivitybySectorBURef}>
                                                <div className='coman-chart-title'>{!flag ? "YTD " : ""}
                                                     Productivity by Sector / BU <span>{appConstants.inUSDMillion}</span>
                                                     <span style={{float: 'right', position: 'relative', right: '1rem'}}>
                                                        <DropdownWithIcons modalRef={productivitybySectorBURef} kpiName={"Productivity by Sector / BU"} checkPDFDownloaded={checkPDFDownloaded}/>
                                                    </span>
                                                </div>
                                                {
                                                    ytdProductivityDetails && ytdProductivityDetails.length > 0 ?
                                                        <>
                                                            <VerticalStackedChart data={ytdProductivityDetails} buColorMap={buColorMap} />
                                                            <LegendList legends={legendsChart1} />
                                                        </> :
                                                        <NoData />
                                                }
                                            </div>
                                            </Col>
                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <div ref={MOMProductivityRef}>
                                                <div className='coman-chart-title'>
                                                    MOM Productivity <span>{appConstants.inUSDMillion}</span>
                                                    <span style={{float: 'right'}}>
                                                        <DropdownWithIcons modalRef={MOMProductivityRef} kpiName={"MOM Productivity"} checkPDFDownloaded={checkPDFDownloaded}/>
                                                    </span>
                                                </div>
                                                {
                                                    momProductivityDetails && momProductivityDetails.length > 0 ?
                                                        <>
                                                            <MOMProductivityChart data={momProductivityDetails} />
                                                            <LegendList legends={legendsChart2} />
                                                        </> :
                                                        <NoData />
                                                }
                                            </div>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                            </Row>
                            <br />
                            <Row gutter={[10, 10]} justify="start" style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    <Card>
                                        <Row gutter={[10, 10]} justify={"space-between"} style={{ width: "100%" }}>
                                            
                                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                <div ref={ProductivityCostLineTableRef}>
                                                    {
                                                        dataSource && dataSource.length > 0 ?
                                                            <>
                                                                <div className='coman-chart-title' style={{marginBottom: '-40px'}}>
                                                                    {!flag ? "YTD view of " : ""}Productivity by {costLineHcmPlank?.[0]?.['displayText']} <span>{appConstants.inUSDMillion}</span>
                                                                    <span style={{float: 'right', position: 'relative', bottom: '0.5rem'}}>
                                                                        <DropdownWithIcons modalRef={ProductivityCostLineTableRef} kpiName={costLineHcmPlank?.[0]?.['value'] == "costLine" ? 'Productivity by Cost Line (in USD Million)' : 'Productivity by HCM Plank (in USD Million)'} checkPDFDownloaded={checkPDFDownloaded} isTable={true}/>
                                                                    </span>
                                                                </div>
                                                                <br />
                                                                
                                                            {/* <button type="primary" title='Download Data' onClick={downloadExcel} className="download-excel-powersteering">
                                                                                    <img src={download_logo} alt="download_logo" style={{position: 'relative', top: '2px'}}/>
                                                            </button> */}
                                                                <AntdTable className="powersteering-table" columns={columns} dataSource={sortedData} pagination={{ pageSize: 5, position: ['bottomCenter'], itemActiveBg: 'red', showSizeChanger: false, }} />
                                                            </> :
                                                            <NoData />
                                                    }
                                                </div>
                                                </Col>
                                            
                                            {/* <div className="compass-modal-divider-verticle" /> */}
                                            
                                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                <div ref={ProductivityCostLineChartRef}>
                                                    {
                                                        productivityChartData && productivityChartData.length > 0 ?
                                                            <>
                                                                <div style={{ display: "flex", justifyContent: 'space-between' }}>
                                                                    <div className='coman-chart-title'>
                                                                        Productivity by {costLineHcmPlank?.[0]?.['displayText']} <span>{appConstants.inUSDMillion}</span>
                                                                       
                                                                    </div>
                                                                    <br />
                                                                    <div style={{ width: '30%' }}>
                                                                        <SingleSelectDropdown className='buy-con-dropdown-modal' childList={dropdownValue} label="" selectedValue={costLineHcmPlank} setSelectedValue={onDropdownChange} />
                                                                    </div>
                                                                    <span style={{float: 'right', position: 'relative', left: '0.5rem'}}>
                                                                            <DropdownWithIcons modalRef={ProductivityCostLineChartRef} kpiName={costLineHcmPlank?.[0]?.['value'] == "costLine" ? 'Productivity by Cost Line (in USD Million)' : 'Productivity by HCM Plank (in USD Million)'} checkPDFDownloaded={checkPDFDownloaded}/>
                                                                        </span>
                                                                </div>
                                                                <ProductivityChart data={productivityChartData} />
                                                                <LegendList legends={legendsChart1} />
                                                            </> :
                                                            <NoData />
                                                    }
                                                </div>
                                                </Col>
                                            
                                        </Row>
                                    </Card>
                                </Col>
                            </Row>
                            <br />
                            <Row gutter={[10, 10]} justify="start" style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    <Card>
                                        <div className='coman-chart-title'>Top / Bottom 5 Projects by Actual {!flag ? "YTD" : ""} Productivity </div>
                                        <Row gutter={[10, 10]} justify={"space-between"} style={{ width: "100%" }}>
                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                <div ref={top5ProductivityProjectsRef}>
                                                {
                                                    top5ProjectDetails && top5ProjectDetails.length > 0 ?
                                                        <>
                                                            <div className='coman-chart-title'>
                                                                Top 5 projects by Productivity <span>{appConstants.inUSDMillion}</span>
                                                                <span style={{float: 'right'}}>
                                                                    <DropdownWithIcons modalRef={top5ProductivityProjectsRef} kpiName={"Top 5 projects by Productivity (in USD Million)"} checkPDFDownloaded={checkPDFDownloaded}/>
                                                                </span>
                                                            </div>
                                                            <ThreeBarsChart data={top5ProjectDetails} />
                                                            <LegendList legends={legendsChart1} />
                                                        </> :
                                                        <NoData />
                                                }
                                                </div>
                                            </Col>
                                            {/* <div className="compass-modal-divider-verticle" /> */}
                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                <div ref={bottom5ProductivityProjectsRef}>
                                                {
                                                    bottom5ProjectDetails && bottom5ProjectDetails.length > 0 ?
                                                        <>
                                                            <div className='coman-chart-title'>Bottom 5 projects by Productivity <span>{appConstants.inUSDMillion}</span>
                                                                <span style={{float: 'right'}}>
                                                                    <DropdownWithIcons modalRef={bottom5ProductivityProjectsRef} kpiName={"Bottom 5 projects by Productivity (in USD Million)"} checkPDFDownloaded={checkPDFDownloaded}/>
                                                                </span>
                                                            </div>
                                                            <ThreeBarsChart data={bottom5ProjectDetails} />
                                                            {/* <CustomStackedChart/> */}
                                                            <LegendList legends={legendsChart1} />
                                                        </> :
                                                        <NoData />
                                                }
                                                </div>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                            </Row>
                            <br />

                            <div className="spend-modal-manage-spend" style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", width: '100%' }}>
                                {
                                    powersteeringData?.owners?.length > 0 &&
                                    <div style={{width: '100%'}}>Please reach out to {powersteeringData?.owners?.map((contact, index) => (
                                        <React.Fragment key={index}>
                                            <a href={`mailto:${contact.emailId}`} style={{ color: "#005cbc", textDecoration: "None" }}>{contact.emailId}</a>
                                            {index < powersteeringData?.owners?.length - 1 && ', '}
                                        </React.Fragment>
                                    ))} for any query on the data displayed.</div>
                                }
                                <div style={{width: '100%'}}>Please fill in <a href={feedbackFormUrl} target="_blank" style={{ color: "#005cbc", textDecoration: "None" }}>this form</a> for any feedback related to Procurement Hub.</div>
                            </div>
                        </>
                }
                <br/>
            </div>
        </Modal>
    )
}

export default PowerSteeringModal